import { call, put, takeEvery } from "redux-saga/effects"
import {
  GET_EVENTS,
  CHANGE_EVENT_PUBLISH_FIELD,
  UPDATE_CATEGORIZED_EVENT_ORDER,
  UPDATE_EVENT_ORDER,
  HANDLE_DELETE_EVENT,
  HANDLE_EVENT_BULK_DELETE,
  ADD_NEW_EXPERIENCE,
  GET_EVENT_INVITE_LIST,
  SEND_INVITES,
  DELETE_INVITE,
  ADD_ACCESS_CODE,
  ADD_ACCESS_TAG,
  EDIT_ATTENDEE,
  SEND_APP_INVITES,
  UPDATE_RSVP,
  EDIT_ATTENDEE_AND_RSVP,
  DELETE_RSVP,
  UPDATE_EVENT_ACCESS_TYPE,
  GET_EVENT_MENU_LIST,
  UPDATE_EVENT_MENU_FEATURES_ORDER,
  GET_SELECTED_EVENT,
  UPDATE_EXPERIENCE,
  GET_EVENT_ACCESS_CODES,
  GET_INITIAL_ACCESS_TAGS,
  JOIN_EVENT,
  ASSIGN_EVENT_TO_CATEGORY,
  GET_EVENT_CATEGORIES,
  GET_EVENT_CODES,
  UPDATE_BULK_PUBLISH_STATUS,
  SEND_EMAIL_INVITE,
  GET_EVENT_DEEPLINK_URL,
  GET_EVENT_DEEPLINK_CODES,
  GENERATE_DEEPLINK_CODES,
  CLONE_EXPERIENCE,
} from "./actionTypes"
import {
  getEventsSuccess,
  getEventsFailed,
  showLoadingIndicator,
  hideLoadingIndicator,
  updateExperienceFailed,
  updateExperienceSuccess,
  getEventAccessCodesFailed,
  getEventAccessCodesSuccess,
  getInitialAccessTagsFailed,
  getInitialAccessTagsSuccess,
  joinEventSuccess,
  joinEventFailed,
  getEventCategoriesFailed,
  getEventCategoriesSuccess,
  getEventCodesFailed,
  getEventCodesSuccess,
  updateBulkPublishStatusSuccess,
  updateBulkPublishStatusFailed,
  openExperiencesErrorModal,
  sendEmailInviteFailed,
  sendEmailInviteSuccess,
  getEventDeepLinkUrlSuccess,
  getEventDeepLinkCodesFailed,
  getEventDeepLinkCodesSuccess,
  generateDeepLinkCodesFailed,
  hideGenerateDeeplinkModal,
  generateDeepLinkCodesSuccess,
  getEventDeepLinkCodes as getEventDeeplinkCodesAction,
  cloneExperienceFailed,
  cloneExperienceSuccess,
} from "./actions"

import { get, post, axiosPut, del, postImageAxios } from "helpers/api_helper"
import * as url from "helpers/url_helper"
import {
  changeEventPublishFieldSuccess,
  changeEventPublishFieldFailed,
  updateCategorizedEventsOrderFailed,
  updateCategorizedEventsOrderSuccess,
  updateEventOrderFailed,
  updateEventOrderSuccess,
  hidePublishNotificationModal,
  handleDeleteEventFailed,
  handleDeleteEventSuccess,
  hideDeleteEventModal,
  handleEventBulkDeleteFailed,
  handleEventBulkDeleteSuccess,
  hideEventBulkDeleteModal,
  addNewExperienceSuccess,
  getSelectedEventSuccess,
  addNewExperienceFailed,
  getEventInviteListSuccess,
  getEventInviteListFailed,
  sendInvitesFailed,
  sendInvitesSuccess,
  deleteInviteFailed,
  deleteInviteSuccess,
  addAccessCodeFailed,
  addAccessCodeSuccess,
  addAccessTagFailed,
  addAccessTagSuccess,
  openSavingModal,
  hideSavingModal,
  editAttendeeFailed,
  editAttendeeSuccess,
  sendAppInvitesFailed,
  sendAppInvitesSuccess,
  updateRsvpFailed,
  editAttendeeAndRsvpSuccess,
  editAttendeeAndRsvpFailed,
  updateRsvpSuccess,
  deleteRsvpFailed,
  deleteRsvpSuccess,
  updateEventAccessTypeFailed,
  updateEventAccessTypeSuccess,
  getEventMenuListFailed,
  getEventMenuListSuccess,
  updateEventMenuFeaturesOrderFailed,
  updateEventMenuFeaturesOrderSuccess,
  hideDeleteFeatureModal,
  getSelectedEventFailed,
  setIsOutdated,
  getFeatureDeeplinkCodes,
  hideGenerateFeatureDeeplinkModal,
} from "store/actions"
import { getFormDataFromJSON, showToast } from "utils"

function* fetchExperiences({ payload: params }) {
  try {
    yield put(showLoadingIndicator())
    const response = yield get(url.GET_EXPERIENCES_URL, params)
    yield put(getEventsSuccess(response))
    yield put(hideLoadingIndicator())
  } catch (error) {
    yield put(getEventsFailed(error))
    yield put(hideLoadingIndicator())
  }
}
function* changeEventPublishField({ payload: params }) {
  try {
    const response = yield axiosPut(
      `${url.GET_EXPERIENCES_URL}/${params.data.id}`,
      params.data
    )
    yield put(
      changeEventPublishFieldSuccess({ data: response, type: params?.type })
    )
    yield put(hidePublishNotificationModal())
  } catch ({ response }) {
    yield put(changeEventPublishFieldFailed(response.data))
    yield put(hidePublishNotificationModal())
    showToast("error", response?.data?.error || "Error", "Error")
  }
}

function* updateCategorizedEventsOrder({ payload: params }) {
  try {
    yield post(url.POST_EXPERIENCES_ORDER, params.params)
    yield put(updateCategorizedEventsOrderSuccess())
  } catch (error) {
    yield put(updateCategorizedEventsOrderFailed(error))
  }
}

function* updateEventOrder({ payload: params }) {
  try {
    yield post(url.POST_EXPERIENCES_ORDER, params.params)
    yield put(updateEventOrderSuccess())
  } catch (error) {
    yield put(updateEventOrderFailed(error))
  }
}

function* updateBulkPublishStatus({ payload: { callback, ...params } }) {
  try {
    yield post(url.UPDATE_EVENT_PUBLISHED_FIELD, params?.values)
    yield put(updateBulkPublishStatusSuccess(params?.values))
    if (callback) {
      callback()
    }
    showToast("success", "Experiences updated", "Success")
  } catch ({ response }) {
    yield put(updateBulkPublishStatusFailed(response?.data))
    showToast("error", response?.data?.error || "Error", "Error")
    if (callback) {
      callback()
    }
    yield put(openExperiencesErrorModal(response?.data?.error))
  }
}

function* handleDeleteEvent({ payload: event }) {
  try {
    yield del(`${url.GET_EXPERIENCES_URL}/${event.id}`)
    yield put(handleDeleteEventSuccess(event))
    yield put(hideDeleteEventModal())
  } catch (error) {
    yield put(handleDeleteEventFailed(error))
  }
}

function* handleEventBulkDelete({ payload: events }) {
  try {
    yield post(url.EVENT_BULK_DELETE, events)
    yield put(handleEventBulkDeleteSuccess(events))
    yield put(hideEventBulkDeleteModal())
  } catch (error) {
    yield put(handleEventBulkDeleteFailed(error))
  }
}

function* addNewExperience({ payload: params }) {
  try {
    yield put(openSavingModal())
    const response = yield post(url.GET_EXPERIENCES_URL, params.experience)
    yield put(addNewExperienceSuccess(response))
    yield put(hideSavingModal())
  } catch (error) {
    console.error(error)
    yield put(addNewExperienceFailed(error))
  }
}

function* sendInvites({ payload: { params, sortOptions, vendorId, eventId } }) {
  try {
    yield put(openSavingModal())
    yield post(url.POST_INVITES_URL, params)
    const response = yield get(
      `${url.GET_EVENT_INVITE_LIST_URL}/${vendorId}/event/${eventId}`,
      { params: sortOptions }
    )
    yield put(getEventInviteListSuccess(response))
    const selectedEvent = yield get(
      `${url.GET_EXPERIENCES_URL}/${params.invites[0].event_id}`
    )
    yield put(getSelectedEventSuccess(selectedEvent))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(sendInvitesFailed(error))
  }
}

function* getEventInviteList({ payload: { vendorId, eventId, sortOptions } }) {
  try {
    const response = yield get(
      `${url.GET_EVENT_INVITE_LIST_URL}/${vendorId}/event/${eventId}`,
      { params: sortOptions }
    )
    yield put(getEventInviteListSuccess(response))
  } catch (error) {
    yield put(getEventInviteListFailed(error))
  }
}

function* deleteInvite({ payload: { callback, ...params } }) {
  try {
    const response = yield del(url.INVITE_URL, {
      invite_ids: params?.invite_ids,
    })
    yield put(deleteInviteSuccess(response))
    if (callback) {
      callback()
    }
    showToast("success", "Invite Deleted", "Success")
  } catch (error) {
    yield put(deleteInviteFailed(error))
    if (callback) {
      callback()
    }
    showToast("error", error, "Error")
  }
}

function* addAccessCode({ payload: { postImageParams, event_id } }) {
  try {
    const postImageResponse = yield postImageAxios("/qr", postImageParams)
    const addImageResponse = yield post("/qr", {
      event_id: event_id,
      image: postImageResponse[0].image,
      type: postImageResponse[0].type,
      word: postImageResponse[0].word,
    })
    yield put(addAccessCodeSuccess(addImageResponse))
  } catch (error) {
    yield put(addAccessCodeFailed(error))
  }
}

function* addAccessTag({ payload: { params, sortOptions } }) {
  try {
    yield post(
      `${url.GET_EXPERIENCES_URL}/${params.event_id}/meta-tags`,
      params
    )
    yield put(addAccessTagSuccess())
    const response = yield get(
      `${url.GET_EVENT_INVITE_LIST_URL}/${params.vendor_id}/event/${params.event_id}`,
      { params: sortOptions }
    )
    yield put(getEventInviteListSuccess(response))
  } catch (error) {
    yield put(addAccessTagFailed(error))
  }
}

function* getEventAccessCodes({ payload: params }) {
  try {
    const response = yield get("/qr", { params })
    yield put(getEventAccessCodesSuccess(response))
  } catch (error) {
    yield put(getEventAccessCodesFailed(error))
  }
}

function* editAttendee({ payload: params }) {
  try {
    const response = yield axiosPut(
      `${url.INVITE_URL}/${params.invite_id}`,
      params
    )
    yield put(editAttendeeSuccess(response))
  } catch (error) {
    yield put(editAttendeeFailed(error))
  }
}

function* sendAppInvites({ payload: { callback, ...params } }) {
  try {
    yield post(url.SEND_APP_INVITES_URL, params?.values)
    yield put(sendAppInvitesSuccess())
    if (callback) {
      callback()
    }
    showToast("success", "Invite(s) sent!", "Success")
  } catch (error) {
    yield put(sendAppInvitesFailed(error))
    if (callback) {
      callback()
    }
    showToast("error", error, "Error")
  }
}

function* updateRsvp({
  payload: { eventId, vendorId, rsvp, eventInviteListSortOptions },
}) {
  try {
    yield axiosPut(`/event/${eventId}/rsvp/${rsvp.id}`, rsvp)
    const response = yield get(
      `${url.GET_EVENT_INVITE_LIST_URL}/${vendorId}/event/${eventId}`,
      { params: eventInviteListSortOptions }
    )
    yield put(updateRsvpSuccess(response))
  } catch (error) {
    yield put(updateRsvpFailed(error))
  }
}

function* editAttendeeAndRsvp({ payload: { eventId, rsvp, attendee } }) {
  try {
    yield axiosPut(`/event/${eventId}/rsvp/${rsvp.id}`, rsvp)
    const response = yield axiosPut(
      `${url.INVITE_URL}/${attendee.invite_id}`,
      attendee
    )
    yield put(editAttendeeAndRsvpSuccess(response))
  } catch (error) {
    yield put(editAttendeeAndRsvpFailed(error))
  }
}

function* deleteRsvp({ payload: { callback, ...params } }) {
  try {
    const response = yield del(
      `/event/${params?.vendorId}/${params?.eventId}/rsvp`,
      { rsvp_ids: params?.rsvp_ids }
    )
    yield put(deleteRsvpSuccess(response))
    if (callback) {
      callback()
    }
    showToast("success", "RSVP Deleted", "Success")
  } catch (error) {
    yield put(deleteRsvpFailed(error))
    if (callback) {
      callback()
    }
    showToast("error", error, "Error")
  }
}

function* updateEventAccessType({ payload: params }) {
  try {
    const data = { ...params }
    if (params?.timezone === "Asia/Calcutta") {
      data.timezone = "Asia/Kolkata"
    }
    const response = yield axiosPut(
      `${url.GET_EXPERIENCES_URL}/${data?.id}`,
      data
    )
    yield put(updateEventAccessTypeSuccess(response))
  } catch (error) {
    yield put(updateEventAccessTypeFailed(error))
  }
}

function* getEventMenuList({ payload: params }) {
  try {
    const response = yield get(url.EVENT_DROPDOWN_LIST_URL, params)
    yield put(getEventMenuListSuccess(response))
  } catch (error) {
    yield put(getEventMenuListFailed(error))
  }
}

function* updateEventMenuFeaturesOrder({ payload: { params, eventId } }) {
  try {
    const response = yield post(
      `/admin/event/${params.vendor_id}/${eventId}/design`,
      params
    )
    yield put(updateEventMenuFeaturesOrderSuccess(response))
  } catch (error) {
    yield put(updateEventMenuFeaturesOrderFailed(error))
  }
}

function* getEvent({ payload: params }) {
  try {
    const response = yield get(`${url.GET_EXPERIENCES_URL}/${params}`)
    yield put(getSelectedEventSuccess(response))
  } catch (error) {
    yield put(getSelectedEventFailed(error))
  }
}

function* updateExperience({ payload: params }) {
  try {
    yield put(openSavingModal())
    const experience = yield axiosPut(
      `/admin/event/${params.experience.id}`,
      params.experience
    )
    let design = params.design
    if (Object.keys(params.background).length !== 0) {
      if (params.background?.files) {
        const backgroundResponse = yield postImageAxios(
          "/file",
          getFormDataFromJSON(params.background)
        )
        design = {
          ...design,
          bg_image: "custom",
          bg_image_file: backgroundResponse[0],
        }
      } else {
        design = {
          ...design,
          bg_image: "default",
          delete_background_image: 1,
        }
      }
    }
    if (Object.keys(params.thumbnail).length !== 0) {
      if (params.thumbnail?.files) {
        const thumbnailResponse = yield postImageAxios(
          "/file",
          getFormDataFromJSON(params.thumbnail)
        )
        design = {
          ...design,
          event_thumbnail: "custom",
          event_thumbnail_file: thumbnailResponse[0],
        }
      } else {
        design = {
          ...design,
          event_thumbnail: "default",
          delete_event_thumbnail: 1,
        }
      }
    }
    const designResp = yield post(
      `/admin/event/${params.experience.vendor_id}/${params.experience.id}/design`,
      {
        ...params.design,
        ...design,
      }
    )
    const event = { ...experience, design: designResp }
    yield put(updateExperienceSuccess(event))
    yield put(hideSavingModal())
    showToast("success", "Experience updated", "Success")
  } catch ({ response }) {
    yield put(updateExperienceFailed(response))
    yield put(hideSavingModal())
    showToast(
      "error",
      response?.data?.error || "Something went wrong! Please try again!",
      "Error"
    )
  }
}

function* getInitialAccessTags({ payload: params }) {
  try {
    const response = yield get(`/admin/event/${params.event_id}/meta-tags`, {
      params: { type: 1 },
    })
    yield put(getInitialAccessTagsSuccess(response))
  } catch (error) {
    yield put(getInitialAccessTagsFailed(error))
  }
}

function* joinEvent({ payload: params }) {
  try {
    const response = yield post(`/event/${params.eventId}/join-event`)
    yield put(joinEventSuccess(response.rsvps))
  } catch (error) {
    yield put(joinEventFailed(error))
  }
}

function* assignEventToCategory({ payload: params }) {
  try {
    yield post(`/admin/event/${params.event_id}/categories`, params)
  } catch (error) {
    console.log(error)
  }
}

function* getEventCategories({ payload: params }) {
  try {
    const response = yield get(`/admin/event/${params.event_id}/categories`)
    yield put(getEventCategoriesSuccess(response))
  } catch (error) {
    yield put(getEventCategoriesFailed(error))
  }
}

function* getEventCodes({ payload: params }) {
  try {
    const response = yield get(`/admin/event/${params?.eventId}/codes`)
    yield put(getEventCodesSuccess(response))
  } catch (error) {
    yield put(getEventCodesFailed(error))
  }
}

function* sendEmailInvite({ payload: params }) {
  try {
    const response = yield post("/admin/invite/send", params)
    yield put(sendEmailInviteSuccess(response))
    showToast("success", "Invite(s) sent", "Success")
  } catch (error) {
    yield put(sendEmailInviteFailed(error))
    showToast("error", error, "Error")
  }
}

function* getEventDeepLinkUrl({ payload: params }) {
  try {
    const response = yield get(`/admin/event/${params?.id}/deeplink-url`)
    yield put(getEventDeepLinkUrlSuccess(response))
  } catch (error) {
    yield put("error", error, "Error")
  }
}

function* getEventDeeplinkCodes({ payload: params }) {
  try {
    const response = yield get(url.DEEPLINK_CODES_URL, { params })
    yield put(getEventDeepLinkCodesSuccess(response))
  } catch (error) {
    yield put(getEventDeepLinkCodesFailed(error))
  }
}

function* generateDeepLinkCodes({ payload: { callback, ...params } }) {
  try {
    const response = yield post(url.DEEPLINK_CODES_URL, params)
    yield put(generateDeepLinkCodesSuccess())
    if (!!params?.menu_item_id) {
      yield put(
        getFeatureDeeplinkCodes({
          o: "created_at",
          od: "desc",
          page: 1,
          per_page: 10,
          type: params?.type,
          event_id: params?.event_id,
          menu_item_id: params?.menu_item_id,
        })
      )
    } else {
      yield put(
        getEventDeeplinkCodesAction({
          o: "created_at",
          od: "desc",
          page: 1,
          per_page: 25,
          type: params?.type,
          event_id: params?.event_id,
        })
      )
    }
    if (callback) {
      callback()
    }
    if (!!params?.menu_item_id) {
      yield put(hideGenerateFeatureDeeplinkModal({}))
    } else {
      yield put(hideGenerateDeeplinkModal({}))
    }
    showToast("success", "Deeplinks generated!", "Success")
  } catch (error) {
    yield put(generateDeepLinkCodesFailed(error))
    if (!!params?.menu_item_id) {
      yield put(hideGenerateFeatureDeeplinkModal({}))
    } else {
      yield put(hideGenerateDeeplinkModal({}))
    }
    showToast("error", error, "Error")
  }
}

function* cloneExperience({ payload: params }) {
  try {
    const response = yield post(url.CLONE_EXPERIENCE_URL, params?.data)
    if (params?.history) {
      params?.history.push(`/events/${response?.vendor_id}/${response?.id}`)
    }
    yield put(cloneExperienceSuccess(response))
  } catch (error) {
    yield put(cloneExperienceFailed(error))
    showToast("error", error, "Error")
  }
}

function* experiencesSaga() {
  yield takeEvery(GET_EVENTS, fetchExperiences)
  yield takeEvery(CHANGE_EVENT_PUBLISH_FIELD, changeEventPublishField)
  yield takeEvery(UPDATE_CATEGORIZED_EVENT_ORDER, updateCategorizedEventsOrder)
  yield takeEvery(UPDATE_EVENT_ORDER, updateEventOrder)
  yield takeEvery(UPDATE_BULK_PUBLISH_STATUS, updateBulkPublishStatus)
  yield takeEvery(HANDLE_DELETE_EVENT, handleDeleteEvent)
  yield takeEvery(HANDLE_EVENT_BULK_DELETE, handleEventBulkDelete)
  yield takeEvery(ADD_NEW_EXPERIENCE, addNewExperience)
  yield takeEvery(SEND_INVITES, sendInvites)
  yield takeEvery(GET_EVENT_INVITE_LIST, getEventInviteList)
  yield takeEvery(DELETE_INVITE, deleteInvite)
  yield takeEvery(ADD_ACCESS_CODE, addAccessCode)
  yield takeEvery(ADD_ACCESS_TAG, addAccessTag)
  yield takeEvery(EDIT_ATTENDEE, editAttendee)
  yield takeEvery(SEND_APP_INVITES, sendAppInvites)
  yield takeEvery(UPDATE_RSVP, updateRsvp)
  yield takeEvery(EDIT_ATTENDEE_AND_RSVP, editAttendeeAndRsvp)
  yield takeEvery(DELETE_RSVP, deleteRsvp)
  yield takeEvery(UPDATE_EVENT_ACCESS_TYPE, updateEventAccessType)
  yield takeEvery(GET_EVENT_MENU_LIST, getEventMenuList)
  yield takeEvery(
    UPDATE_EVENT_MENU_FEATURES_ORDER,
    updateEventMenuFeaturesOrder
  )
  yield takeEvery(GET_SELECTED_EVENT, getEvent)
  yield takeEvery(UPDATE_EXPERIENCE, updateExperience)
  yield takeEvery(GET_EVENT_ACCESS_CODES, getEventAccessCodes)
  yield takeEvery(GET_INITIAL_ACCESS_TAGS, getInitialAccessTags)
  yield takeEvery(JOIN_EVENT, joinEvent)
  yield takeEvery(ASSIGN_EVENT_TO_CATEGORY, assignEventToCategory)
  yield takeEvery(GET_EVENT_CATEGORIES, getEventCategories)
  yield takeEvery(GET_EVENT_CODES, getEventCodes)
  yield takeEvery(SEND_EMAIL_INVITE, sendEmailInvite)
  yield takeEvery(GET_EVENT_DEEPLINK_URL, getEventDeepLinkUrl)
  yield takeEvery(GET_EVENT_DEEPLINK_CODES, getEventDeeplinkCodes)
  yield takeEvery(GENERATE_DEEPLINK_CODES, generateDeepLinkCodes)
  yield takeEvery(CLONE_EXPERIENCE, cloneExperience)
}

export default experiencesSaga
